<template>
  <div id="app">
    <b-navbar id="topnav" toggleable="lg" type="dark">
      <b-navbar-brand href="/">HTWWWCG V2.0</b-navbar-brand>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item href="/">Home</b-nav-item>
          <b-nav-item href="/crawling-game">Crawling Man Game *NEW*</b-nav-item>
          <b-nav-item href="/testimonials">Testimonials</b-nav-item>
          <b-nav-item href="/contact">Contact Us</b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <router-view/>
    <b-navbar bottom class="mt-4">
      <p>&copy; 2019 Fisrender Web Design</p>
    </b-navbar>
  </div>
</template>

<script>
export default {

}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #bfd8f1;
  min-height: 100vh;
  background-color: #222;
}

#topnav {
  background-color: rgb(49, 14, 82);
}
</style>
